const container = document.documentElement;

const SCROLL_LOCK_CLASS = "scroll-lock";

const isLocked = document.querySelector(SCROLL_LOCK_CLASS);

function lock() {
  if (container || !isLocked) {
    container.classList.add(SCROLL_LOCK_CLASS);
  }
}

function unLock() {
  if (container || isLocked) {
    container.classList.remove(SCROLL_LOCK_CLASS);
  }
}

export default {
  lock,
  unLock
};
